import styled, { css } from 'styled-components'

const Text = styled.span`
  ${({
    theme: {
      colors: { textDefault },
      typography: {
        bodycopy: {
          small2: { bundledCSS: bodycopySmall2CSS },
        },
      },
    },
  }) => css`
    color: ${textDefault};
    ${bodycopySmall2CSS};
  `}
`

export default Text
